import React from "react";

function Error() {
  return (
    <>
      <div className="notFoundErr">Oh Ohh! 404 Not Found</div>
    </>
  );
}

export default Error;